export default __webpack_public_path__ + "static/media/hnklogo.53eec015.png";